import { useSearchParams } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";
import { Card, Notice } from "../components/ui";
import config from "../config";
import googleButton from "../images/btn_google_signin_dark_normal_web.png";
import logo from "../logos/sidekick.svg";
import { colors, fonts } from "../style";

const style = {
  page: {
    minHeight: "100vh",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px",
    padding: "48px 16px",
    background: colors.pageBackground,
    fontFamily: fonts.system,
    color: colors.textStrong,
  },
  card: {
    width: "100%",
    maxWidth: "360px",
    boxSizing: "border-box",
    padding: "36px 28px 32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "28px",
    background: colors.sidebar,
  },
  loginButtons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  loginButton: {
    width: "190px",
    paddingLeft: 0,
    paddingRight: 0,
    height: "40px",
    borderRadius: "4px",
  },
};

function Login() {
  const [searchParams] = useSearchParams();
  const err = searchParams.get("err");

  const getMsLoginUrl = () => {
    const url = `${config.api_url}/login/microsoft?spa_app_url=${config.app_url}&product=${config.product}`;

    if (config.customer === "next") {
      return url + "&type=next";
    }

    return url;
  };

  const getGoogleLoginUrl = () => {
    const url = `${config.api_url}/login/google?spa_app_url=${config.app_url}&product=${config.product}`;

    if (config.customer === "next") {
      return url + "&type=next";
    }

    return url;
  };

  return (
    <div style={style.page}>
      <Card style={style.card}>
        <img height="96" src={logo} alt="Logo" />

        <div style={style.loginButtons}>
          <Button
            as="a"
            href={getMsLoginUrl()}
            style={{
              ...style.loginButton,
              background: "#00A4EF",
              color: "white",
            }}
          >
            <Icon name="windows" /> Sign in with Microsoft
          </Button>

          {config.customer !== "next" && (
            <a href={getGoogleLoginUrl()}>
              <img src={googleButton} alt="Google Login" />
            </a>
          )}
        </div>
      </Card>

      {err === "ulExceeded" && (
        <Notice tone="error" style={{ maxWidth: "360px" }}>
          Your organisation has exceeded it's user license allowance
        </Notice>
      )}

      <a
        href={config.privacy_policy_url}
        target="_blank"
        rel="noreferrer"
        style={{ fontSize: "13px" }}
      >
        Privacy Policy
      </a>
    </div>
  );
}

export default Login;
